import { ClockIcon, VideoCameraIcon, CalendarIcon, GlobeAltIcon, MapPinIcon, MapIcon } from '@heroicons/react/outline';
import { FaLocationArrow } from 'react-icons/fa';
// heroBannerData.js
export const pagedata = {
  id: 1,
  slug: "be-the-panel",
  typingText: "Be The Panel",
  heroData: {
    title: [
      { id: 1, text: "SCORE MORE" },
      { id: 2, text: " Study Less", className: "text-white-color" },
    ],
    typingTitle: [
        { id: 1, text: "Be The Panel" },
        { id: 2, text: ["5 Aspirants", "30 Mins Each", 'Open Feedback', 'More Confidence'], className: "text-white-color" },
      ],
    description: [
      { id: 2, text: "Get Ready to practice for ", className: "text-white-color" },
      { id: 1, text: "RAS 2023 Interviews" },
      { id: 3, text: ", ", className: "text-white-color" },
      { id: 4, text: "first slot free" },
      { id: 3, text: " of ", className: "text-white-color" },
      { id: 4, text: "Be The Panel" },
    ],
    videoId: "949108417",
    videoUrl: "https://iframe.mediadelivery.net/embed/263741/9e3feea7-7681-4db0-853c-74c8a23e7d62",
    videoThumbnailUrl: "https://vz-dbeb695c-154.b-cdn.net/9e3feea7-7681-4db0-853c-74c8a23e7d62/thumbnail_244289d8.jpg",
    backgroundImageUrl: "https://assets-global.website-files.com/5fdb2866020c200cd7fd7369/61613e3e518d5e0ab00a6319_header-background-image.jpg",
    eventDetails: {
      showinfluencer: false,
      influencerName: "Aayushi",
      influencerShortBio: "15000+ Students | Chartered Accountant | First Attempt | CFA L1 & CS Executive | Ex-PwC",
      influencerBannerImage: "https://toppernotes.s3.ap-south-1.amazonaws.com/images/kJ2q5dgmpnX17varc399.png",
      numberOfDays: 5,
      typeSessions: "Live + Recorded",
      startDate: "1st July 2024",
      registerTill: "15/07/2024 19:00:00",
      registerTillZone: "August 23, 2022 17:00:00 PDT",
      showRegisterButtonText: false,
      timeOfSessions: "6 to 9PM",
      joinButtonLabel: "Book free demo slot!",
      salePrice: 0,
      originalPrice: 1999,
      bonusesWorth: 4999,
      joinTagLine: "Demo tag line",
      seatsLeft: 49,
      showSeatsLeftOnBanner: false,
      showPriceOnBanner: false,
      totalSeats: 100,
      bottomButtonText: "Book free demo slot",
      eventtype: 'masterclass',
      eventTimer: {
        days: 12,
        hours: 12,
        minutes: 34,
        seconds: 12
      },
      title: [
        { id: 1, text: "Join us for the ", className: "text-black-color" },
        { id: 2, text: "Workshop" },
      ],
      eventChips: [
        {
          imgSrc: "https://assets-global.website-files.com/5fdb2866020c200cd7fd7369/61613e3e518d5e6aef0a6318_Vectorclock.svg",
          alt: "Clock Icon",
          icon: ClockIcon,
          heading: `2.5 Hrs Slot`,
        },
        {
          imgSrc: "https://assets-global.website-files.com/5fdb2866020c200cd7fd7369/61613e3e518d5e39520a6335_Vectortv-.svg",
          alt: "Live Icon",
          icon: FaLocationArrow,
          heading: "Offline @ Center",
        },
        {
          imgSrc: "https://assets-global.website-files.com/5fdb2866020c200cd7fd7369/61613e3e518d5e82bd0a6336_Vectorcalender.svg",
          alt: "Calendar Icon",
          icon: CalendarIcon,
          heading: "Every Day",
        },
        {
          imgSrc: "https://assets-global.website-files.com/5fdb2866020c200cd7fd7369/61613e3e518d5e494a0a6337_Vectorclock%20(1).svg",
          alt: "Time Icon",
          icon: GlobeAltIcon,
          heading: "English/Hindi",
        },
      ]
    }
  },
  theme: {
    style: 'light', // 'light'
    gradient1: '#fb9c47',
    gradient2: '#c56816',
    accordion: '#fb9c47',
    accordionChipFill: '#fb9c47',
    accordionChipText: '#fff',
    accordionHeader: '#fff',
    primary: '#8217ee',
    secondary: '#e0257e',
    textColorButton: '#fff',
    imageFillColor: '#fff',
    bgcolorchip: {
      light: '#fb9c4740', // Color for light theme
      dark: '#121212'   // Color for dark theme
    },
    bgcolorcontainer: {
      light: '#fb9c4740', // Color for light theme
      dark: '#1a1a1a'   // Color for dark theme
    }
  },
  brands: {
  },
  superMentorData: {
    pagetitle: "Meet Aayushi",
    mentorName: "Aayushi",
    title:
      "<strong>Chartered Accountant,</strong> CFA Level 1 &amp; CS Executive. She is <strong>Ex-PwC</strong>",
    bio: [
      "She has cleared <strong>CA in her first attempt</strong> and holds CFA Level 1 and CS Executive certifications.",
      "Beyond academics, Aayushi focuses on personal growth, her training has impacted <strong>over 25,000 people</strong>, making her a significant force in education.",
      "<strong>Formerly with PwC</strong>, she aims to help 100,000 students transform their lives through her workshops in the next two years.",
      "Award-winning coach, recognized with the prestigious <strong>Unicorn Coach Award</strong> and the <strong>Crore Club Award</strong>.&nbsp;",
      "She has delivered impactful <strong>offline sessions</strong> at esteemed institutions like <strong>NAHATA Academy</strong> in Indore and <strong>Inspire Academy</strong> in Pune. Her expertise extends to online platforms, where she has conducted sessions for <strong>National IAS Academy, CICASA, WICASA, NIRC</strong>, and other renowned organizations.",
    ],
    socialCounts: {
      instagram: "11.4K",
      youtube: "3.2K",
      linkedin: "7K",
    },
    images: {
      mainImage:
        "https://toppersnotes-videos.b-cdn.net/webinars-programs/ayushi-pics/WhatsApp%20Image%202024-07-08%20at%202.59.48%20PM.jpeg",
      sliderImages: [
        "https://toppersnotes-videos.b-cdn.net/webinars-programs/ayushi-pics/IMG_8696-ezgif.com-resize.webp",
        "https://toppersnotes-videos.b-cdn.net/webinars-programs/ayushi-pics/B612_20240718_113705_354-ezgif.com-resize.webp",
        "https://toppersnotes-videos.b-cdn.net/webinars-programs/ayushi-pics/IMG_8632-ezgif.com-resize.webp",
        "https://toppersnotes-videos.b-cdn.net/webinars-programs/ayushi-pics/IMG_5715-ezgif.com-resize.webp",
      ],
    },
  },
  imagetestimonials: {
    title: [
      { id: 2, text: "Love" },
      { id: 1, text: " Notes from Our", className: "text-white-color" },
      { id: 3, text: " Students" },

    ],
    content: [
      {
        image: 'https://d14a823tufvajd.cloudfront.net/images/o4dQyN7IYOcvNRVcVSC3.webp'
      },
      {
        image: 'https://d14a823tufvajd.cloudfront.net/images/tSfkN27iUN2whz3wfolY.webp'
      },
      {
        image: 'https://d14a823tufvajd.cloudfront.net/images/9UIsf3k2IAAH8LsAJC2J.webp'
      },
      {
        image: 'https://d14a823tufvajd.cloudfront.net/images/MN3yU8Nu1dd1xgaiZm8o.webp'
      },
      {
        image: 'https://d14a823tufvajd.cloudfront.net/images/TFQfPDMmA4kejU0gAbRw.webp'
      },
      {
        image: 'https://d14a823tufvajd.cloudfront.net/images/qw3iSejQ2jKIKjQF2h1r.webp'
      },
      {
        image: 'https://d14a823tufvajd.cloudfront.net/images/tlVTYtVNRtQ7FrurbpFs.webp'
      },
      {
        image: 'https://d14a823tufvajd.cloudfront.net/images/YTHQh03oix7fhZTxNM5r.webp'
      },
      {
        image: 'https://d14a823tufvajd.cloudfront.net/images/ZIFVhmwsd4pC6xoxbPl4.webp'
      }
    ]
  },
  learninggoals: {
  },
  targets: {
  },
  imagetestimonials: {
    title: [
        { id: 1, text: "What", className: "text-white-color"},
        { id: 2, text: " our past students" },
        { id: 3, text: " say", className: "text-white-color"},
    ],
    content: [
        {
          image: 'https://toppersnotes.b-cdn.net/Landing%20page%20files/be-the-panel/WhatsApp%20Image%202025-03-03%20at%2011.51.35%20AM%20(1).webp'
        },
        {
          image: 'https://toppersnotes.b-cdn.net/Landing%20page%20files/be-the-panel/WhatsApp%20Image%202025-03-03%20at%2011.51.35%20AM%20(2).webp'
        },
        {
          image: 'https://toppersnotes.b-cdn.net/Landing%20page%20files/be-the-panel/WhatsApp%20Image%202025-03-03%20at%2011.51.35%20AM.webp'
        },
        {
          image: 'https://toppersnotes.b-cdn.net/Landing%20page%20files/be-the-panel/WhatsApp%20Image%202025-03-03%20at%2011.51.36%20AM.webp'
        }
      ]
},
  nottargets: {
  },
  numbers: {
    title: [
      { id: 2, text: "Numbers" },
      { id: 1, text: " speaking", className: "text-white-color" },
    ],
    content: [
      { id: 1, type: "title-first", heading: "15,100+", title: "Students Enrolled", images: ["https://assets-global.website-files.com/64ede0a591d8114fdaa0ae7f/65eae333ddc74095430422cb_User%20images%20(2).webp"] },
      { id: 2, type: "image-first", heading: "4.8/5", title: "Google Ratings (580+)", images: ["https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-5.svg"] },
      { id: 5, type: "bigger-card", heading: "Free Bonuses worth ₹4999", title: "", images: ["https://d14a823tufvajd.cloudfront.net/images/AYqKg0OGZ3vwPp3ZrWn6.png"] }
    ]
},
    about : {
        title: [
            { id: 1, text: "Meet", className: "text-white-color"},
            { id: 2, text: " Aayushi" },
        ],
        bio: "<p>Aayushi Garg, a <strong>Chartered Accountant</strong> and <strong>Passionate Trainer</strong> &amp; <strong>Career Coach</strong>, spearheads a mission to revolutionize how India studies. With a focus on <strong>efficient</strong> and <strong>smart study techniques</strong>, Aayushi <strong>empowers students</strong> to ace exams <strong>without exhaustive hours of study</strong>. Her impact extends to people of <strong>all ages,&nbsp;&nbsp;</strong>students, working professionals, and housewives. Guiding them to achieve <strong>dream qualifications</strong> and <strong>degrees</strong>.</p> <p>What sets Aayushi apart is her <strong>holistic approach</strong>. Beyond academic success, she aims to cultivate a <strong>positive transformation</strong>, helping individuals become <strong>better versions</strong> of themselves for a <strong>successful</strong> and <strong>fulfilling life</strong> and <strong>career</strong>. Having <strong>influenced</strong> over <strong>25,000+</strong> through her training programs, Aayushi stands as an influential personality who left a corporate career to shape a brighter educational future for others.</p> <p>She is on a <strong>mission to help 1 lakh students</strong> to achieve their goals and transforming their lives through her training workshops in the next two years. She aims to contribute to Nation building by creating a <strong>powerful army of students </strong>with a warrior like confidence.</p>",
        image: "https://lh3.googleusercontent.com/m5v_0rrQvH4MkXZ9GJnvdwjlh6ckdnBDeWf2dHlQJf3drxngE1AJz7LSgixf0vDtnxTh3WqZor9v2H5HYFg5Nu2ERk8R0aJp5Q=w968",
        video: ""
    },
    benefits : {
        title: [
            { id: 2, text: "Benefits" },
            { id: 1, text: " from this workshop", className: "text-white-color"},
        ],
        points: [
            { value: 'No mobile addiction', description: 'Get rid of mobile addiction forever' },
            { value: 'Wake up @5AM', description: 'wake up in BRAHMA MAHURATA every day like a clock' },
            { value: 'Overcome Distractions', description: 'overcome PROCASTINATION AND DISTRACTIONS while studying' },
            { value: 'Magical Formula', description: 'Magical Formula to Score More and Study Less' },
            { value: "Toppers's Mind", description: 'The hidden secrets of Toppers mind' },
          ]
    },
    mentors: {
        title: [
            { id: 3, text: "Meet your ", className: "text-white-color"},
            { id: 2, text: "Mentors" },
        ],
        content: [
            {
              name: 'Jasraj Suthar',
              post: 'RAS 2021 - Rank 448 <br> Rajasthan Cooperative Subordinate Services',
              big: true,
              image: 'https://toppersnotes-videos.b-cdn.net/webinars-programs/be-the-panel/Jasrajji-ezgif.com-png-to-webp-converter.webp',
              companyIcons: [],
            },
            {
              name: 'Bhajanlal Jangid',
              post: 'RAS 2021 - Rank 39 <br> Rajasthan Police Services (RPS)',
              big: true,
              image: 'https://toppersnotes-videos.b-cdn.net/webinars-programs/be-the-panel/Bhajanlalji-ezgif.com-png-to-webp-converter.webp',
              companyIcons: [],
            },
          ]
    },
    texttestimonials: {
        title: [
            { id: 3, text: "What ", className: "text-white-color"},
            { id: 2, text: "our past students" },
            { id: 1, text: " are saying", className: "text-white-color"},
        ],
        useSlider: false,
        content: [
        {
          name: 'Dharshne Senbagam',
          post: 'CA Final Student',
          image: 'https://user-images.trustpilot.com/6605aa957d1fce00124e075a/73x73.png',
          feedback: "<div > <h2 >Worth the money spent</h2> <p >Highly informative workshop which I would recommend for every student. It was an eye opening moment for a CA inter repeater like me. I badly regret for not knowing about mam and her workshop earlier. But I feel lucky that I was able to attend her session atleast now. My confidence level has boosted a lot. Gained immense knowledge by spending just few rupees. Lovely recorded and live classes.</p> <p ><strong>Date of experience:</strong> March 28, 2024</p> </div>",
          rating: 5
        },
        {
        name: 'Gayathri Murugan',
        // post: 'BCA Student',
        image: 'https://user-images.trustpilot.com/6619f4f4427b7a0011a69d47/73x73.png',
        feedback: "<div ><h2 >Life transformation</h2><p >Mam really excited and overwhelmed by the way the classes and it's valuable inputs are useful<br />100 times Worth of the money and time spent <br />I repent for knowing about this 5 days workshop very late</p><p ><strong>Date of experience:</strong> April 13, 2024</p></div>",
        rating: 5
        },
      {
        name: 'Nahush Junnarkar',
        // post: '12th Board, HR College, Mumbai',
        image: 'https://user-images.trustpilot.com/65749c6a51045c0012c01252/73x73.png',
        feedback: "<div> <h2>The session was very helpful for me</h2> <p>The session was very helpful for me, especially the early riser session. I struggled a lot to wake up early but the hacks shared in the session were scientifically correct and also practical. Also the part where <strong>CA Ayushi Garg</strong> tells about science behind addiction and how to overcome mobile addiction was mind blowing.</p> <p><strong>Date of experience:</strong> December 09, 2023</p> </div>",
        rating: 5
        },
        {
        name: 'Keerthi Pradeep',
        // post: 'CA IPCC Student',
        image: 'https://user-images.trustpilot.com/6562bedb40646e00124ae942/73x73.png',
        feedback: "<div > <h2 >5 days masterclass was an amazing&hellip;</h2> <p >5 days masterclass was an amazing experience for me.<br />Even the introduction was filled with positivity, these classes make me feel that i will be able to clear the exam and i'm capable for that. each day was very helpful and kept motivated to study .Eagerly waiting for day 5 live class. Thank you so much for this oppurtunity . I LOVED IT</p> <p ><strong>Date of experience:</strong> November 26, 2023</p> </div>",
        rating: 5
        },
      {
        name: 'Shruti Batra',
        // post: 'CA Final Student',
        image: "https://user-images.trustpilot.com/65b5395e0395ff001241aa96/73x73.png",
        feedback: "<div > <h2 >A Great help for those who need guidance and motivation&hellip;</h2> <p >A Great help for those who need guidance in their student journey. This Masterclass helped me in knowing all the pros and cons about my study schedule, planning etc. It has motivated me a lot. Helps in improving productivity. Thanks to our mentor.</p> <p ><strong>Date of experience:</strong> January 26, 2024</p> </div>",
        rating: 5
  
  
      },
      {
        name: 'Supriya Aravind',
        // post: 'CA Final Student',
        image: "https://user-images.trustpilot.com/6619653d3d419800121115d6/73x73.png",
        feedback: "<div > <h2 >Must attended workshop to know where&hellip;</h2> <p >Must attended workshop to know where you are going wrong in study technique. U will get to know the purpose of why towards your goal. Once I know the purpose you will be unstoppable.</p> <p ><strong>Date of experience:</strong> April 12, 2024</p> </div>",
        rating: 5
      },
        ]
        },
        videotestimonials: {
    title: [
      { id: 3, text: "Video Diaries:  ", className: "text-white-color" },
      { id: 2, text: "Journeys to Success" },
      
      ],
    style: 'card', // 'image' / 'card'
    content: [
      {
        thumbnail: 'https://d14a823tufvajd.cloudfront.net/images/BwNhTHUq0KCRcBekQwTK.webp',
        videoUrl: 'https://iframe.mediadelivery.net/embed/228263/c09806b6-22cc-4445-bf35-d88be9938ead',
        title: 'This workshop has been very helpful',
        name: 'Komal Jain',
        // post: '',
        },
      {
        thumbnail: 'https://d14a823tufvajd.cloudfront.net/images/3G48w1KnPHKqXxTB5N8n.webp',
        videoUrl: 'https://iframe.mediadelivery.net/embed/228263/afb378d1-b7c3-4a86-8809-da9633b94dff',
        title: "Aayushi ma'am teaches really well",
        name: 'Madhumita Choudhary',
        // post: '',
      },
      {
        thumbnail: 'https://d14a823tufvajd.cloudfront.net/images/MXkUmJzqkpgT3yqeuBqE.webp',
        videoUrl: 'https://iframe.mediadelivery.net/embed/228263/2bbf7a91-8232-439d-a513-421b11546a70',
        title: 'This session changed me completely!',
        name: 'Nandini Patel',
        // post: '',
      },
      {
        thumbnail: 'https://d14a823tufvajd.cloudfront.net/images/5inWpf1zJRG1F9Pjgfvt.webp',
        videoUrl: 'https://iframe.mediadelivery.net/embed/228263/49dd4f2a-725f-4133-925d-6380c1d6a760',
        title: 'This session helped me gain my lost confidence',
        name: 'Palak Ghanchi',
        // post: '',
      },
      {
        thumbnail: 'https://d14a823tufvajd.cloudfront.net/images/qCKtRz5zsiZFrNkE05m4.webp',
        videoUrl: 'https://iframe.mediadelivery.net/embed/228263/06169fd1-ecb5-4e76-b80c-611d04ba2613',
        title: 'I learned priceless lessons in this 5 day workshop',
        name: 'Rajeshwari',
        // post: '',
      }
    ]
  },
faqs: {
      title: [
        { id: 2, text: "FAQs" },
        { id: 1, text: " here’s everything you may ask...", className: "text-white-color" }
      ],
      expandedKeys: ["1", "2", "5"],
      content: [
        {
          key: "1",
          question: "What is Be The Panel program?",
          answer: "<p>Be The Panel is a unique initiative where students take turns being the panelists and the interviewees. The program runs for a total duration of 2.5 hours per session, where each interview lasts 20 minutes, followed by 5 minutes of feedback and a 5-minute break.</p>"
        },
        {
          key: "2",
          question: "What are the session timings?",
          answer: "<p>Interviews are conducted three times a day at 9:30 AM, 12:00 PM, and 2:30 PM. You can choose your slot based on availability.</p>"
        },
        {
          key: "3",
          question: "Who will be mentoring the program?",
          answer: "<p>The program will be guided by <strong>Jasraj Suthar, RAS 2021 - Rank 448</strong>, who will take regular mentorship sessions to help aspirants improve their interview performance.</p>"
        },
        {
          key: "4",
          question: "How do I reserve my slot?",
          answer: "<p>You must reserve your slot at least <strong>2 days in advance</strong>. Slots are allocated on a first-come, first-served basis.</p>"
        },
        {
          key: "5",
          question: "Can I cancel my slot or reschedule?",
          answer: "<p>You <strong>cannot cancel</strong> your slot within 2 days of the scheduled interview. If you fail to show up for your interview, you will be <strong>blacklisted</strong> from the program.</p>"
        },
        {
          key: "6",
          question: "What is the fee for the program?",
          answer: "<p>The fee for the program is <strong>INR 1000 for 10 interview sessions</strong>. This is a nominal charge of just <strong>INR 100 per session</strong>, making it highly affordable for aspirants.</p>"
        },
        {
          key: "7",
          question: "Will the interviews be recorded?",
          answer: "<p>No, the interviews are <strong>purely offline</strong>. There will be <strong>no recordings allowed on the premises</strong>, ensuring candidates feel comfortable and confident without being evaluated by external members.</p>"
        },
        {
          key: "8",
          question: "Will I get feedback on my performance?",
          answer: "<p>Yes, every aspirant will receive a <strong>score and performance proforma</strong> after each interview, detailing their strengths and areas for improvement.</p>"
        },
        {
          key: "9",
          question: "Do I need to fill any form before the interview?",
          answer: "<p>Yes, you will be required to fill out a <strong>detailed application form</strong>. This form will be shared with the panelists to help them frame relevant questions for your interview.</p>"
        },
        {
          key: "10",
          question: "Will I know the other students in my panel?",
          answer: "<p>No, you <strong>will not know</strong> who the other four students in your panel will be. This adds a surprise element, making the experience more realistic and dynamic.</p>"
        }
      ]
    }
};